import script from "./SidebarArena.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarArena.vue?vue&type=script&setup=true&lang=js"

import "./SidebarArena.vue?vue&type=style&index=0&id=64c9e652&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c9e652"]])

export default __exports__